import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=6ecda3a8&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=ts&"
export * from "./Stage.vue?vue&type=script&lang=ts&"
import style0 from "./Stage.vue?vue&type=style&index=0&id=6ecda3a8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecda3a8",
  null
  
)

export default component.exports